<template>
    <div id="home">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>Vos notifications</h1>
        <button v-on:click="isInvoiceHide = !isInvoiceHide" class="btnAccordion">
            <font-awesome-icon v-if="isInvoiceHide" icon="angle-up" />
            <font-awesome-icon v-if="!isInvoiceHide" icon="angle-down" />
            &nbsp;&nbsp;Facture à payer ({{invoiceData.length}})
        </button>
        <div  v-if="!isInvoiceHide">
        <div class="notifList" v-for="(item, index) in invoiceData" :key="index">
            <div class="divCard">
                <span class="spanCard notif">
                {{ item.address.streetNb + " " +item.address.streetName}}&nbsp;&nbsp;&nbsp;  -  &nbsp;&nbsp;&nbsp;{{item.type}}
                </span>
                <button v-on:click="goToInvoicePage(item.name)" class="btnCard notifBtn"><font-awesome-icon icon="chevron-right" /></button>
            </div>
        </div>
        </div>
        <hr>
        <button v-on:click="isQuotationHide = !isQuotationHide" class="btnAccordion">
            <font-awesome-icon v-if="isQuotationHide" icon="angle-up" />
            <font-awesome-icon v-if="!isQuotationHide" icon="angle-down" />
            &nbsp;&nbsp;Devis à signer ({{quotationData.length}})
        </button>
        <div  v-if="!isQuotationHide">
        <div class="notifList" v-for="(item, index) in quotationData" :key="index">
            <div class="divCard">
                <span class="spanCard notif">
                {{ item.address.streetNb + " " +item.address.streetName}}&nbsp;&nbsp;&nbsp;  -  &nbsp;&nbsp;&nbsp;{{item.type}}
                </span>
                <button v-on:click="goToQuotationPage(item.name)" class="btnCard notifBtn"><font-awesome-icon icon="chevron-right" /></button>
            </div>
        </div>
        </div>
        <div class="outermargin"></div>
        <h1>Vos biens</h1>
        <div class="search-wrapper">
            <input type="text" v-model="search" placeholder="Rechercher un bien"/>
            <label>Search title:</label>
        </div>
        <div class="card" v-for="(item, index) in filteredBuilding" :key="index">
            <img class="imgCard" :src="dataUrl(index)" alt="SO" />
            <div class="divCard">
                <span class="spanCard">
                <b>{{ item.buildingAddress.firstName + " " +item.buildingAddress.lastName}}</b><br>
                    {{ item.buildingAddress.streetNb + " " +item.buildingAddress.streetName}}<br>
                    {{ item.buildingAddress.postalCode + " " +item.buildingAddress.city}}
                </span>
                <div v-if="getStatus(index)" id="circleRed">{{getStatusNumber(index)}}</div>
                <button class="btnCard" v-on:click="goToBuildingPage(item.name)"><font-awesome-icon icon="chevron-right" /></button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Home',
        data() {
            return {
                buildings : [],
                Name:"Client",
                search: '',
                isInvoiceHide: false,
                isQuotationHide: false,
                inquData: [],
                invoiceData: [],
                quotationData: [],
                invoiceDataLink: [],
                quotationDataLink: []
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('fromQuery');
                this.$cookie.delete('fromPage');
                this.$cookie.delete('fromPagePrev');
                this.$cookie.delete('fromQueryPrev');
                this.$router.replace({ name: "login" });
            },
            async fillInvoiceLink(name){
                name = name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+name);
                this.invoiceDataLink.push({name:name, id:response.data.inquiry.invoice._id});
            },
            async fillQuotationLink(name){
                name = name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+name);
                this.quotationDataLink.push({name:name, id:response.data.inquiry.quotation._id});
            },
            goToInvoicePage(name){
                for(var i=0; i<this.invoiceDataLink.length; i++){
                    if(this.invoiceDataLink[i].name === name){
                        this.$cookie.set('fromPage', "home");
                        this.$cookie.set('fromQuery', "");
                        this.$cookie.set('fromPagePrev', "home");
                        this.$cookie.set('fromQueryPrev', "");
                        this.$router.replace({ name: "invoicepay", query: {name: this.invoiceDataLink[i].id, id:name }});
                    }
                }
            },
            goToQuotationPage(name){
                for(var i=0; i<this.quotationDataLink.length; i++){
                    if(this.quotationDataLink[i].name === name){
                        this.$cookie.set('fromPage', "home");
                        this.$cookie.set('fromQuery', "");
                        this.$cookie.set('fromPagePrev', "home");
                        this.$cookie.set('fromQueryPrev', "");
                        this.$router.replace({ name: "quotation", query: {name: this.quotationDataLink[i].id, id:name}});
                    }
                }
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                location.reload();
            },
            goToBuildingPage(name){
                this.$router.replace({ name: "building", query: {name: name}  });
            },
            goToInquiryPage(name){
                this.$cookie.set('fromPage', "home");
                this.$cookie.set('fromQuery', "");
                this.$cookie.set('fromPagePrev', "home");
                this.$cookie.set('fromQueryPrev', "");
                this.$router.replace({ name: "inquiry", query: {name: name}});
            },
            getStatus(i){
                for(var j=0; j<this.filteredBuilding[i].inquiry.length;j++){
                    if(this.filteredBuilding[i].inquiry[j].status === "à payer" || this.filteredBuilding[i].inquiry[j].status === "à signer"){
                        return true;
                    }
                }
                return false;                
            },
            getStatusNumber(i){
                var nb = 0;
                for(var j=0; j<this.filteredBuilding[i].inquiry.length;j++){
                    if(this.filteredBuilding[i].inquiry[j].status === "à payer" || this.filteredBuilding[i].inquiry[j].status === "à signer"){
                        nb++;
                    }
                }
                return nb;                
            },
            dataUrl(i){
                return 'data:'+this.buildings[i].picture.img.contentType+';base64,' + btoa(
                    new Uint8Array(this.buildings[i].picture.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "client" ){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getBuildings();
                }
            },
            async getBuildings(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building');
                
                if(response.data.buildings){
                    this.buildings = response.data.buildings;
                    for(var j=0; j<this.buildings.length; j++){
                        this.buildings[j].searchData = this.buildings[j].buildingAddress.firstName +" "+
                                                    this.buildings[j].buildingAddress.lastName +" "+
                                                    this.buildings[j].buildingAddress.streetNb +" "+
                                                    this.buildings[j].buildingAddress.streetName +" "+
                                                    this.buildings[j].buildingAddress.postalCode +" "+
                                                    this.buildings[j].buildingAddress.city;
                        for(var i=0; i<this.buildings[j].inquiry.length; i++){
                            if(this.buildings[j].inquiry[i].status === "à signer"){
                                this.quotationData.push({
                                                            address:this.buildings[j].buildingAddress, 
                                                            type:this.buildings[j].inquiry[i].type, 
                                                            name:this.buildings[j].inquiry[i].name
                                                        });
                                this.fillQuotationLink(this.buildings[j].inquiry[i].name);
                            }
                            if(this.buildings[j].inquiry[i].status === "à payer"){
                                this.invoiceData.push({
                                                        address:this.buildings[j].buildingAddress,
                                                        type:this.buildings[j].inquiry[i].type,
                                                        name:this.buildings[j].inquiry[i].name
                                                    });
                                this.fillInvoiceLink(this.buildings[j].inquiry[i].name);
                            }
                        }
                    }
                }
            },
            async getInquiriesStatus(){
                var nameInq = "";
                for(var i=0; i<this.inquData.length; i++){
                    nameInq = this.inquData[i].name.split('/').join('%2F');
                    var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq);
                    if(response.data.inquiry.quotation.status === "à signer"){
                        this.quotationData.push({
                                                    address:this.inquData[i].address,
                                                    type:response.data.inquiry.type, 
                                                    id:response.data.inquiry._id, 
                                                    name:response.data.inquiry.name
                                                });
                    }
                    if(response.data.inquiry.status === "à payer"){
                        this.invoiceData.push({
                                                address:this.inquData[i].address,
                                                type:response.data.inquiry.type,
                                                id:response.data.inquiry.type,
                                                name:response.data.inquiry.name
                                            });
                    }
                }
            }
        },
        mounted(){
            this.getCookies();
        },
        computed: {
            filteredBuilding() {
                return this.buildings.filter(building => {
                    return building.searchData.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #home {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 550;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }
    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    #circleRed {
        width: 16px;
        height: 16px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        border-radius: 8px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: -6px;
        right: 67px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        color:white;
        text-align: center;
        font-size:13px;
        vertical-align: middle;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    #logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
    .card{
        font-family: 'BenchNine', sans-serif;
        margin:10px;
        margin-bottom:10px;
        background-color: #F0F0F0;
        display: inline-block;
        position: relative;
    }
    .imgCard{
        border-bottom: 2px solid;
        border-color:#1ce83e;
        width:150px;
        height: 75px;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 5%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 13px;
    }
    .notif{
        padding-left: 15px;
        font-size: 15px;
    }
    .notifBtn{
        right: 20px;
    }
    .search-wrapper {
        position: relative;
        label {
          position: absolute;
          width: calc(100% - (24px + 2px));
          font-size: 15px;
          color: rgba(0,0,0,.50);
          top: 8px;
          left: 12px;
          z-index: -1;
          transition: .15s all ease-in-out;
          font-family: 'BenchNine', sans-serif;
        }
        input {
          padding: 4px 12px;
          color: rgba(0,0,0,.70);
          border: 1px solid rgba(0,0,0,.12);
          transition: .15s all ease-in-out;
          background: white;
          font-family: 'BenchNine', sans-serif;
          width: calc(100% - (24px + 2px));
          &:focus {
            outline: none;
            transform: scale(1.05);
            & + label  {
              font-size: 13px;
              transform: translateY(-24px) translateX(-12px);
            }
          }
          &::-webkit-input-placeholder {
              font-size: 15px;
              color: rgba(0,0,0,.50);
              font-weight: 100;
          }
        }
    }
    .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .notifList{
        margin-bottom: 7px;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }
</style>